<template>
	<div class="login-page">

		<!-- HEADER -->
		<header>
			<div class="container">
				<div class="row">
					<div class="col">
						<div class="cabecera-2 bg_dg-8">
							<div class="info-contenedor-cb">
								<div class="abr-dependencia _blanco"> SISTEMA INTEGRAL DE FORMACIÓN CONTINUA </div>
							</div> <!--breadcrumb-->
							<nav aria-label="breadcrumb"> </nav>
						</div>
					</div>
				</div>
			</div>
		</header>

		<!-- LOGIN -->
		<section class="login-section py-5">
			<div class="container">
				<div class="row justify-content-center">

					<div class="col-md-6 col-lg-5">
						<div class="card shadow-lg border-0 rounded-4 p-4 text-center">

							<h2 class="mb-2 fw-semibold">Bienvenido</h2>
							<p class="text-muted mb-4">
								Accede al sistema para continuar con tu formación
							</p>

							<img src="https://sifc3.iea.edu.mx/logos/BANNER.png" class="img-fluid rounded mb-2"
								alt="Banner" />

							<div class="d-flex flex-column align-items-center gap-1 mt-2">

								<button class="btn bg-1 px-4" style="min-width: 220px" @click="loginGoogle()">
									Iniciar Sesión
								</button>

								<a class="btn bg-2 px-4" style="min-width: 220px"
									@click="registro()"
									rel="noopener noreferrer">
									Registrarse
								</a>

							</div>
						</div>
					</div>

				</div>
			</div>
		</section>

		<!-- NOTICIAS -->
		<section class="news-section py-5 bg-light">
			<div class="container">

				<div class="text-center mb-4">
					<h3 class="fw-semibold">Noticias y Avisos</h3>
					<p class="text-muted">
						Mantente informado sobre cursos, convocatorias y actualizaciones
					</p>
				</div>

				<div class="row g-4">

					<!-- Noticia 1 -->
					<div class="col-md-4">
						<div class="card h-100 shadow-sm border-0 rounded-4">
							<div class="card-body">
								<span class="badge bg-primary mb-2">Convocatoria</span>
								<h5 class="card-title">
									Apertura de nuevos cursos 2026
								</h5>
								<p class="card-text text-muted">
									Ya están disponibles los nuevos cursos de formación continua.
								</p>
							</div>
						</div>
					</div>

					<!-- Noticia 2 -->
					<div class="col-md-4">
						<div class="card h-100 shadow-sm border-0 rounded-4">
							<div class="card-body">
								<span class="badge bg-success mb-2">Aviso</span>
								<h5 class="card-title">
									Generación de Constancias
								</h5>
								<p class="card-text text-muted">
									Por el momento sólo estará disponible la generación de constancias del año 2025.
								</p>
							</div>
						</div>
					</div>

					<!-- Noticia 3 -->
					<div class="col-md-4">
						<div class="card h-100 shadow-sm border-0 rounded-4">
							<div class="card-body">
								<span class="badge bg-warning text-dark mb-2">Importante</span>
								<h5 class="card-title">
									Actualización de datos
								</h5>
								<p class="card-text text-muted">
									Recuerda mantener tu información personal actualizada.
								</p>
							</div>
						</div>
					</div>

				</div>
			</div>
		</section>

	</div>
</template>

<script>
//import CarruselComponent from './CarruselComponent';
//import AccesoModal from './modals/accesoModal';
//import RegistroIEAModal from './modals/registroIEAModal';
//import FooterComponent from './FooterComponent';
import { queryIEASIS } from './backIeasis/dbContextConexion';


export default {
	name: 'PrincipalComponent',
	components: {
		//CarruselComponent,
		//AccesoModal,
		//RegistroIEAModal,
		//FooterComponent,
	},
	data() {
		return {
			gCuenta: '',
			modalSelectAcceso: false,
			modalRegistroIEA: false,
			url: process.env.VUE_APP_URL,
			url2: null,
			token: null,
			bandera: null,
		};
	},
	mounted() {
		console.log('GCUENTA:', this.gCuenta)
		if (localStorage.getItem('email')) {
			this.gCuenta = localStorage.getItem('email')
			this.loginGoogle();
		}


	},
	methods: {
		async loginGoogle() {
			this.modalSelectAcceso = false;
			if (localStorage.getItem('email')) {
				this.gCuenta = localStorage.getItem('email');
			}
			else {
				window.location.href = '/?login'
			}

			if (this.gCuenta) {
				this.loginIEA(this.gCuenta);
			}
		},
		
		msgBox(titulo, mensaje) {
			console.log('titulo,mensaje', titulo, mensaje)
			return this.$bvModal.msgBoxOk(mensaje, {
				title: titulo,
				size: 'md',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'Aceptar',
				headerClass: 'p-2 border-bottom-0',
				footerClass: 'p-2 border-top-0',
				centered: true,
			});
		},
		async loginIEA(gCuenta) {
			console.log('entro a async loginiea')
			console.log(gCuenta);
			if (gCuenta.includes('@iea.edu.mx')) {
				const query = "SELECT a.*,b.* FROM usuarios a INNER JOIN perfiles b ON a.idperfil  = b.idperfil where email = " + '"' + gCuenta + '"'
				const res1 = await queryIEASIS(query)
				const res = res1[0];
				sessionStorage.setItem('perfil', res.perfil);
				if (res) { console.log('RESSSSS', res) } else { console.log('no pude leer') }

				if (res) {
					console.log('Entro en if res de Principal Component!!');
					sessionStorage.setItem('token', this.token);
					console.log('res.perfil!!:', res.perfil);
					sessionStorage.setItem('perfil', res.perfil);

					sessionStorage.setItem('usuario', res.usuario);
					sessionStorage.setItem('id', res.idusuario);
					localStorage.setItem('id', res.idusuario);
					//sessionStorage.setItem("perfil")
					this.$router.push({ path: '/dashboard/perfil', query: "" })
					location.reload();
				} else {
					console.log('Error de consulta');
					this.msgBox(
						'Cuenta no registrada',
						'La cuenta no ha sido registrada, de clic en aceptar para realizar un registro con esta cuenta'
					)
					this.modalRegistroIEA = true;
				}

			} else {
				this.msgBox(
					'Dominio no válido',
					'La cuenta no pertenece al dominio @iea.edu.mx'
				);
			}
		},
		registro(){
			this.$router.push('/registro');
		}
	},
};
</script>

<style lang="css">
.titulo {
	text-align: center;
	margin-top: 20px;
}

.animcolorAzul {
	background-color: rgba(29, 0, 107, 0.767);
	cursor: pointer;
	transition: 1s;
}

.animcolorAzul:hover {
	background-color: rgb(218, 0, 125);
}

.animcolorGris {
	background-color: rgba(99, 99, 99, 0.767);
	cursor: pointer;
	transition: 1s;
}

.animcolorGris:hover {
	background-color: rgb(182, 211, 80);
}
</style>
